import {
    Button,
    Box,
    Text,
    Badge,
    Input,
    InputRightElement,
    InputGroup,
    useToast,
    Flex,
    Icon,
    Tooltip,
    IconButton,
    useColorModeValue,
    Tr,
    Td
} from "@chakra-ui/react";
import React from "react";
import { FiCopy, FiTrash2, FiUser, FiTag } from 'react-icons/fi';

const CouponCard = ({
    id,
    couponCode,
    couponPrice,
    isExpired,
    OpenBlockModal,
    email,
    themeColor,
    textColor,
    subTextColor
}) => {
    const toast = useToast();

    const CopyToClipBoard = () => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                toast({
                    status: "info",
                    title: `Code copied`,
                    isClosable: true,
                    duration: 1000,
                    position: "bottom-right",
                });
            })
            .catch((error) => {
                console.error("Failed to copy text: ", error);
                toast({
                    status: "error",
                    title: `Error copying code`,
                    isClosable: true,
                    duration: 1000,
                });
            });
    };

    return (
        <Tr>
            <Td>
                <InputGroup size="sm" maxW="200px">
                    <Input
                        value={couponCode}
                        readOnly
                        pr="2.5rem"
                        fontSize="sm"
                        fontWeight="medium"
                        bg={useColorModeValue("gray.50", "gray.700")}
                        border="none"
                        borderRadius="md"
                    />
                    <InputRightElement width="2.5rem">
                        <Tooltip label="Copy Code" hasArrow>
                            <IconButton
                                h="1.5rem"
                                size="xs"
                                onClick={CopyToClipBoard}
                                icon={<FiCopy />}
                                variant="ghost"
                                color="gray.500"
                                aria-label="Copy code"
                            />
                        </Tooltip>
                    </InputRightElement>
                </InputGroup>
            </Td>
            <Td>
                <Flex align="center" gap={2}>
                    <Icon as={FiTag} color={themeColor} />
                    <Text fontWeight="medium" color={textColor}>₹{couponPrice}</Text>
                </Flex>
            </Td>
            <Td>
                <Badge colorScheme={isExpired ? "red" : "green"} borderRadius="full" px={2}>
                    {isExpired ? 'Expired' : 'Active'}
                </Badge>
            </Td>
            <Td>
                <Flex align="center" gap={2} color={subTextColor} fontSize="sm">
                    <Icon as={FiUser} />
                    <Text noOfLines={1} maxW="150px">
                        {email && email.length ? email : 'Not used yet'}
                    </Text>
                </Flex>
            </Td>
            <Td>
                {
                    !isExpired &&
                <IconButton
                    aria-label="Delete Coupon"
                    icon={<FiTrash2 />}
                    colorScheme="red"
                    variant="ghost"
                    size="sm"
                    onClick={() => OpenBlockModal(id)}
                    _hover={{ bg: "red.50" }}
                />
                }
            </Td>
        </Tr>
    );
};

export default CouponCard;
